import { __read } from 'tslib';
import * as React from 'react';

var DEVICES_TO_DETECT = ['Android', 'BlackBerry', 'iPhone', 'iPad', 'iPod', 'Opera Mini', 'IEMobile', 'WPDesktop'];
var useDetectMobileDevice = function () {
    var _a = __read(React.useState(false), 2), isMobile = _a[0], setMobile = _a[1];
    React.useEffect(function () {
        var userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
        var mobile = DEVICES_TO_DETECT.some(function (device) { return userAgent.match(device); });
        setMobile(mobile);
    }, []);
    return isMobile;
};

export { DEVICES_TO_DETECT, useDetectMobileDevice };
//# sourceMappingURL=useDetectMobileDevice.esm.js.map
